/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { EConnectionStatusId } from '@/main/pages/PageAccountInfo/types/pageAccountInfoGeneralTypes';
import { colors, fonts } from '@theme/index';

interface IEmdConnectionTitleStyled {
  statusId: EConnectionStatusId | undefined;
}

export const EmdConnectionStatusContainerStyled = styled.section`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  & .connection-deadline__info {
    margin-bottom: 24px;
  }
`;

export const EmdConnectionStatusStyled = styled.div`
  display: grid;
  border: 1px solid ${colors.borderColorLight};
  padding: 16px;
`;

export const EmdConnectionTitleStyled = styled.h5<IEmdConnectionTitleStyled>`
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 8px;
  align-items: center;
  justify-content: space-between;
  height: min-content;
  margin-top: 0;
  margin-bottom: 24px;

  & .edm-connection-status {
    justify-self: end;
    ${fonts.textMain};
    color: ${(props) =>
      props.statusId === EConnectionStatusId.CONNECTED
        ? colors.textColorSuccess
        : colors.textColorOpacity};
  }
`;

export const EmdConnectionInfoStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(112px, max-content) 1fr;
  row-gap: 16px;
  column-gap: 32px;
`;

export const EmdConnectionLabelStyled = styled.span`
  color: ${colors.textColorOpacity};
`;

export const EmdResponsibleContactStyled = styled.span`
  display: grid;
`;
export const EmdConnectionOptionsStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
  column-gap: 24px;
  justify-items: start;
  margin-top: 16px;
`;

export const EmdConnectionOptionStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  column-gap: 8px;
  align-items: center;
  color: ${colors.textLinkColor};
`;

export const EmdConnectionErrorLstStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li:not(:last-child) {
    margin-bottom: 6px;
  }
`;
